<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'home'"
    class="page page--home"
  >
    <div class="page__header bc--secondary pt3 pb1">
      <div class="row--evenly mh4">
        <div class="row--start">
          <img
            @click="$router.push({path: '/introduction'})"
            :src="composable.member.info.clinic==='璟馨'?
              require('@/assets/images/icon-introduction-璟馨.png'):
              require('@/assets/images/icon-introduction-詠馨.png')
            "
            alt=""
            class="image--size-y-2"
          >
        </div>
        <div class="row--central">
          <img
            @click="changeClinic"
            :src="composable.member.info.clinic==='璟馨'?
              require('@/assets/images/icon-name-璟馨.png'):
              require('@/assets/images/icon-name-詠馨.png')
            "
            alt=""
            class="image--size-y-2"
          >
        </div>
        <div
          v-if="composable.member.info.status==='in'"
          class="row--end"
        >
          <img
            @click="$router.push({path: '/member/setting'})"
            src="@/assets/images/icon-member-setting.png"
            alt=""
            class="image--size-y-2"
          >
        </div>
        <div
          v-else
          class="row--end"
        >
          <img
            @click="$router.push({path: '/member/login'})"
            src="@/assets/images/icon-login.png"
            alt=""
            class="image--size-y-2"
          >
        </div>
      </div>
    </div>
    <div class="page__is-expanded">
      <div
        :style="{
          'background-image':`url(
            ${composable.member.info.clinic==='璟馨'?
            require('@/assets/images/img-main-璟馨.png'):
            require('@/assets/images/img-main-詠馨.png')
          }
            )`,
        }"
        class="page__background-image"
      >
        <img
          src="@/assets/images/curve-header.png"
          alt=""
        >
        <img
          src="@/assets/images/curve-home-middle.png"
          alt=""
          :style="{
            position: 'absolute',
            bottom: 0
          }"
        >
      </div>
    </div>
    <div class="page__is-expanded pt4">
      <div class="row--evenly mb3">
        <div class="row--start">
          <img
            @click="$router.push({path: '/appointment'})"
            src="@/assets/images/icon-appointment.png"
            alt=""
            class="image--size-y-4"
          >
        </div>
        <div class="row--central">
          <div class="column--central">
            <img
              @click="callClinic"
              src="@/assets/images/icon-call.png"
              alt=""
              class="image--size-y-4"
            >
          </div>
        </div>
        <div class="row--end">
          <img
            @click="$router.push({path: '/progress'})"
            src="@/assets/images/icon-progress.png"
            alt=""
            class="image--size-y-4"
          >
        </div>
      </div>
      <!-- <div
        @click="$router.push({path: '/test'})"
        class="mb3"
      >
        直撥預約
      </div> -->
      <div
        class="mb3"
      >
        直撥預約
      </div>
      <img
        src="@/assets/images/curve-home-bottom.png"
        alt=""
      >
    </div>
    <div class="page__footer bc--secondary pv3">
      <div class="row--evenly">
        <div class="row--central">
          <img
            @click="composable.member.info.status==='in'?
              $router.push({path: '/inbox'}):
              showToLoginModal('如欲查看訊息中心，請先登入您的帳號')
            "
            src="@/assets/images/icon-inbox.png"
            alt=""
            class="image--size-y-2"
          >
        </div>
        <div class="row--central">
          <img
            @click="toHibaby()"
            src="@/assets/images/icon-hibaby.png"
            alt=""
            class="image--size-y-2"
          >
        </div>
        <div class="row--central">
          <img
            @click="$router.push({path: '/feedback'})"
            src="@/assets/images/icon-feedback.png"
            alt=""
            class="image--size-y-2"
          >
        </div>
      </div>
    </div>
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
    @toLogin="toLogin"
  />
</template>

<script>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import composable from '@/composable/index';
import api from '@/api/index';
import spiderman from '@/spiderman/index';

export default {
  setup() {
    const page = ref('home');
    const route = useRoute();
    const router = useRouter();

    async function changeClinic() {
      try {
        composable.member.changeClinic();

        composable.loading.show('切換院區中，請稍候');

        if (composable.member.info.status === 'in') {
          await api.member.changeClinic(composable.member);
        }
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    function showToLoginModal(message) {
      composable.modal.show({
        body: message,
        footer: [
          { content: '前往登入頁面', type: 'primary', onClickEmit: 'toLogin' },
        ],
      });
    }

    function toLogin() {
      composable.modal.close();
      router.push({ path: '/member/login' });
    }

    function toHibaby() {
      if (composable.member.info.status === 'out') {
        showToLoginModal('如欲查看超音波影像，請先登入您的帳號');
        return;
      }
      if (composable.member.info.clinic !== '璟馨') {
        composable.modal.popup('目前僅有璟馨院區開放超音波影像功能');
        return;
      }
      router.push({ path: '/hibaby' });
    }

    function callClinic() {
      const { phone } = spiderman.clinic[composable.member.info.clinic];
      const cmd = spiderman.generate.specialCommand({
        cmd: 'browse',
        url: `tel:${phone}`,
        timestamp: spiderman.generate.timestamp(),
      });
      router.replace(`${route.path}#inncom#${cmd}`);
    }

    return {
      page,
      composable,
      changeClinic,
      showToLoginModal,
      toLogin,
      toHibaby,
      callClinic,
    };
  },
};
</script>
